<template>
    <div class="chart-01">    
        <v-doughnut-chart :chart-data="datacollection" :options="options"></v-doughnut-chart>
        <p v-text="data[0]+'%'" class="mb-0 text-center"></p>
    </div>
</template>

<script>
import DoughnutChart from '../../../charts/DoughnutChart';

export default {
    components: {
        DoughnutChart,
    },
    props: [
        'data',
    ],
    data() { return {
        datacollection: null,
        options: null,
    }},
    mounted() {
        this.fillData();
    },
    methods: {
        fillData() {
            this.datacollection = {
                datasets: [
                    {
                        data: this.data,
                        backgroundColor: ['#39ccc6', '#d1f8f6'],
                    }
                ],
                labels: ['Atendidos', 'Sin resolver'], 
            };
            this.options = {
                legend: {
                    display: false,
                },
                circumference: 2 * Math.PI,
            }
        },
    },
}
</script>